import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PartsComponent } from '../Shared/PartsControl/PartsComponent';
import { ConfirmationDialog } from 'src/app/Core/ConfirmationDialog';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'note-dialog',
  templateUrl: './NoteDialog.html',
  styleUrls: ['./NoteDialog.css']
})
export class NoteDialog implements AfterViewInit {

  matDialogRef: MatDialogRef<ConfirmationDialog>;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<NoteDialog>, public decimalpipe:DecimalPipe) {

    //dialogRef.updateSize('700px', 'auto');
  }

  public showHours = true;
  public showParts = false;
  public PrevParts = [];
  public PartList = [];
  public NoteList = [];
  notes = '';
  hours = '0.00';
  errormsg = '';
  @ViewChild(PartsComponent, { static: false })
  NoteParts: PartsComponent;
  @Output() SaveEvent = new EventEmitter<string>();

  @ViewChild('noteId', { static: true }) inputEl: ElementRef;

  public API;
  public DivisionId;
  public EquipementId;
  public CurrentUserId;
  public partscategoryname;
  public status;
  public NoteHeader = 'Notes';
    private _initialNotes = '';
    private _initialHours = '0.00';
    private _initialPartTransJson = '';
    private _initialNoteListJson = '';
  ngOnInit() {
    // if (this.showParts === true) {
    //   this.dialogRef.updateSize('90%', 'auto');
    // }
  }

  ngAfterViewInit() {
    if (this.showParts === true) {
      this.NoteParts.API = this.API;
      this.NoteParts.SelectedDialysisUnits = this.DivisionId;
      this.NoteParts.SelectedEquipment = this.EquipementId;
      this.NoteParts.currentUserId = this.CurrentUserId;
      this.NoteParts.partscategoryname = this.partscategoryname;
      this.NoteParts.status = this.status;
      this.NoteParts.PrevParts = this.PrevParts;
      this.NoteParts.PartTrans = this.PartList;
    }

    setTimeout(() => {this.inputEl.nativeElement.focus()},500);

    // Capture initial snapshots for change detection
    this._initialNotes = (this.notes ?? '').toString();
    this._initialHours = (parseFloat(this.hours as any || 0) || 0).toFixed(2);
    this._initialNoteListJson = JSON.stringify(this.NoteList || []);
    if (this.showParts === true && this.NoteParts) {
      this._initialPartTransJson = JSON.stringify(this.NoteParts.PartTrans || []);
    } else {
      this._initialPartTransJson = JSON.stringify([]);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  PlusHours()
  {
    if(parseFloat(this.hours)<12)
    {
      this.hours = (parseFloat(this.hours.toString()) + 0.25).toString();

    this.hours = this.formatDecimal(this.hours.toString());
  }
}

  MinusHours()
  {
    if(parseFloat(this.hours)>0.0)
    {
      this.hours = (parseFloat(this.hours.toString()) - 0.25).toString();

    this.hours = this.formatDecimal(this.hours.toString());
  }
}

  formatDecimal(val) {
    //let val = this.f[ctl].value;
//     if (val.length > 0) {
//       if (val.indexOf('.') === -1) {
//         val = val + ".0" ;
//       }
//
//       if (val.substring(val.indexOf('.') + 1, val.length - val.indexOf('.') + 1).length  == 1) {
//         val = val + "0" ;
//       }
      return this.decimalpipe.transform(val, '1.2-2');
    // }
  }

  private hasChanges(): boolean {
    // Notes text changed
    const curNotes = (this.notes ?? '').toString();
    if ((curNotes || '').trim() !== (this._initialNotes || '').trim()) return true;

    // Hours changed (only when shown)
    if (this.showHours === true) {
      const curHours = (parseFloat(this.hours as any || 0) || 0).toFixed(2);
      if (curHours !== (this._initialHours || '0.00')) return true;
    }

    // Note list changed
    const curNoteListJson = JSON.stringify(this.NoteList || []);
    if (curNoteListJson !== (this._initialNoteListJson || '[]')) return true;

    // Parts changed (only when shown)
    if (this.showParts === true && this.NoteParts) {
      const curPartsJson = JSON.stringify(this.NoteParts.PartTrans || []);
      if (curPartsJson !== (this._initialPartTransJson || '[]')) return true;
    }

    return false;
  }

  saveAndClose() {

    if (this.notes != '' || (this.showParts === true && this.NoteParts.PartTrans.length > 0)) {
        // this.matDialogRef = this.dialog.open(ConfirmationDialog, {
        //   disableClose: true
        // });
        // this.matDialogRef.componentInstance.confirmMessage =
        //   'You have unsaved changes! If you leave, your changes will be lost.';
        // this.matDialogRef.afterClosed().subscribe(result => {

        //     if(result)
        //       this.dialogRef.close(false);
        //     else
              this.save();
          // });
      }
     else {
      this.dialogRef.close(false);
    }
  }

  save() {

    this.errormsg = '';
    // if (this.showHours === true && parseFloat(this.hours) === 0) {
    //   this.errormsg = 'Hours Required';
    //   return false;
    // }
    // if (this.showHours === true && this.hours.match(/^(\d*)(\.\d{1,2})?$/) == null) {
  // if (this.showHours === true) {
  //   this.errormsg = '(##.##) Format';
  //     return false;
  //   }
    if (this.notes === '' && (this.NoteList && this.NoteList.length <= 0)) {
      this.errormsg = 'Note Required';
      return false;
    }

    const isPartSelectionEmpty = !this.NoteParts?.PartSelectedItem || Object.keys(this.NoteParts?.PartSelectedItem).length === 0;

    if (this.showParts === true) {
      if (this.NoteParts.PartSearchTerm !== '' || !isPartSelectionEmpty) {
        this.errormsg = 'Please add selected parts';
        return false;
      }
    }

    const notes = this.notes?.trim();



    if (this.showHours === true) {
      if (this.hasChanges()) {
        if (notes) {
          this.SaveEvent.emit(`${notes}|${this.hours}`);
        } else {
          this.SaveEvent.emit('');
        }
      } else {
        this.dialogRef.close(false);
        return;
      }
    } else {
      if (this.hasChanges()) {
        if (notes) {
          this.SaveEvent.emit(notes);
        } else {
          this.SaveEvent.emit('');
        }
      } else {
        this.dialogRef.close(false);
        return;
      }
    }
    this.dialogRef.close(true);
  }
  public confirmMessage: string;
}
